import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../locales/localeSlice";
import { setLocale } from "../../locales/localeSlice";
import { arrowGlobal } from "../../../public/assets";
import styled from "styled-components";
import fipayFonts from "../../theme/index";
import { useLocalStorage } from "usehooks-ts";

const Translator: React.FC = () => {
  const usFlag = "🇺🇸";
  const esFlag = "🇪🇸";
  const [language, setLanguage] = useLocalStorage("locale", "en");

  const dispatch = useDispatch();
  const currentLocale = useSelector((state: RootState) => state.locale.locale);
  const [flag, setFlag] = useState(usFlag);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const openCountrySelect = () => {
    setIsOpen(!isOpen);
  };
  // const handleCloseLanguage = () => {
  //   setIsOpen(true);
  // };

  const handleLocaleChange = (newLocale: string) => {
    // setIsOpen(true);
    setIsOpen(!isOpen);

    dispatch(setLocale(newLocale));
    setLanguage(newLocale);
    if (newLocale === "en") {
      setFlag(usFlag);
    }
    if (newLocale === "es") {
      setFlag(esFlag);
    }
  };

  // const toggleDropdown = () => {
  //   setIsOpen(!isOpen);
  // };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !(dropdownRef.current as unknown as HTMLElement).contains(
        event.target as Node
      )
    ) {
      closeDropdown();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    dispatch(setLocale(language));
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    dispatch(setLocale(language));
  }, [language]);

  // const close = () => {
  //   setIsOpen(false);
  // };

  const globalButtonStyle = {
    border: "none",
  };

  return (
    <div className="" ref={dropdownRef}>
      <div style={globalButtonStyle} title={currentLocale}>
        <ImageContainer>
          <img
            src="/assets/icons/arrowGlobal.png"
            alt="global"
            onClick={openCountrySelect}
          />
        </ImageContainer>
        {isOpen && (
          <>
            <WordCard>
              <Language onClick={() => handleLocaleChange("en")}>
                <img src="/assets/icons/usa.png" alt="Us Flag" />
                <CountryText>English</CountryText>
              </Language>
              <Language onClick={() => handleLocaleChange("es")}>
                <img src="/assets/icons/spanish.png" alt="Spanish Flag" />
                <CountryText>Espanol</CountryText>
              </Language>
            </WordCard>
          </>
        )}
      </div>
    </div>
  );
};

export default Translator;

const ImageContainer = styled.div`
  margin-left: 40px;
  cursor: pointer;
  @media screen and (min-width: 0px) and (max-width: 767px) {
    margin-left: 0;
  }
`;

const WordCard = styled.div`
  width: 150px;
  height: auto;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  margin-top: 10px;
  position: absolute;
  right: 0%;
  top: 100%;
  z-index: 2;

  img {
    width: 15%;
    height: 15%;
  }
`;

const CountryText = styled.h3`
  margin-left: 15px;
  font-size: ${fipayFonts.fipayFonts.fontSize.body4};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
`;

const Language = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  &:hover {
    background-color: #f0f0f0;
    border-radius: 8px;
  }
  cursor: pointer;
  img {
    border-radius: 50%;
  }
`;
